import { useEffect, useState, useRef, memo } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import history from "../../../history";
import "react-confirm-alert/src/react-confirm-alert.css";
import ShopMap from "./ShopMap";
import {
  Modal,
  Col,
  Row,
  Overlay,
  Button,
  Popover,
  Container,
  Card,
  CardBody,
} from "react-bootstrap";
import { connect } from "react-redux";

import { VzPageContainer } from "../../../layouts/VzPageContainer";
import { useParams, useHistory } from "react-router-dom";
import axios from "../../../apis/Api";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../../layouts/Input/FormikControl";
import { Input } from "reactstrap";
import ReactSelect from "react-select";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import CustomDataTable from "../../../layouts/DataTables/CustomDataTable";
import ScrollableNoPagingDataTable from "../../../layouts/DataTables/ScrollableNoPagingDataTable";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { Collapse } from "react-bootstrap";
import { getDropdownList } from "../../Shared/dropdownListActions";
import { renderCell, renderHeader } from "../../../utilities/FUNCTIONS";
import { GET_DISTRIBUTOR_DDL } from "../../../Types";
const EditShop = (props) => {
  const { id, request, readOnly } = useParams();

  const _readOnly = readOnly == "true";

  const [shopData, setShopData] = useState(null);
  const [shopCategories, setShopCategories] = useState([]);
  const [subLocalities, setSubsetSubLocalities] = useState([]);
  const [mfiList, setMfiList] = useState([]);
  const [rsoList, setRsoList] = useState([]);
  const [distributorList, setDistributorList] = useState([]);

  const [rsoModal, setRsoModal] = useState(false);
  const [selectedRso, setSelectedRso] = useState(null);
  const [walletModal, setWalletModal] = useState(false);
  const [distributorModal, setDistributorModal] = useState(false);

  const toggleValues = {
    profileInformation: true,
    contactInformation: true,
    address: true,
    wallet: true,
    distributorProfile: true,
    agents: true,
  };
  const [showSection, setShowSection] = useState(toggleValues);

  const getShopData = () => {
    axios
      .get(`api/VizShop/GetVizShopForWeb/${id}/${request}`)
      .then(({ data }) => {
        if (data?.cityId) {
          getSubsetSubLocalities(data.cityId);
        }
        data.request = request == "true";
        setShopData(data);
      })
      .catch(function (error) {});
  };

  const initialValues = {
    vizShopCode: "",
    cnic: "",
    cnicExpiry: "",
    vizShopName: "",
    shopCategory: "",
    address: "",
    locality: "",
    area: "",
    lat: "",
    long: "",
    mapAddress: "",
    reasonDetailsOfWalletOrBank: "",
    selectedReasonForWalletOrBank: "",
    isActive: false,
    isShopOwnerHavePhoneNo: false,
    cityId: "",
    request: false,
  };

  const toggleSection = (name) => {
    setShowSection({ ...showSection, [name]: !showSection[name] });
  };

  const getShopCategories = () => {
    axios
      .get(`api/VizShop/GetShopCategories`)
      .then(({ data }) => {
        setShopCategories(
          data?.response?.map(function (item) {
            return {
              value: item.name,
              label: item.name,
            };
          })
        );
      })
      .catch(function (error) {});
  };

  const getSubsetSubLocalities = (cityId) => {
    axios
      .get(`api/Area/${cityId}`)
      .then(({ data }) => {
        setSubsetSubLocalities(
          data?.response?.map(function (item) {
            return {
              value: item.name,
              label: item.name,
            };
          })
        );
      })
      .catch(function (error) {});
  };

  const getMfis = () => {
    axios
      .get(`api/Mfi`)
      .then(({ data }) => {
        setMfiList(
          data
            .filter((x) => x.isDropDown == true)
            ?.map(function (item) {
              return {
                value: item.id,
                label: item.mfiName,
              };
            })
        );
      })
      .catch(function (error) {});
  };

  const getRsoList = () => {
    axios
      .get(`api/User/GetRSODDL`)
      .then(({ data }) => {
        setRsoList(
          data?.response?.map(function (item) {
            return {
              value: item.value,
              label: item.label,
            };
          })
        );
      })
      .catch(function (error) {});
  };

  const getDistributorList = () => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
  };

  const saveShopData = () => {
    axios
      .post(`api/VizShop/UpdateVizShopForWeb`, shopData)
      .then(({ data }) => {
        toast.success("Shop updated");
        if (request == "true") {
          history.push(`/VizShopsRequestListing`);
          history.go(`/VizShopsRequestListing`);
        } else {
          history.push(`/vizLinkShopsList`);
          history.go(`/vizLinkShopsList`);
        }
      })
      .catch(function (error) {});
  };

  const openRsoModal = () => {
    let rso = rsoList.find((x) => x.value == shopData?.rsoId);
    setSelectedRso(rso);
    setRsoModal(true);
  };

  const setNewRso = () => {
    let model = {
      id: id,
      rsoId: selectedRso.value,
    };

    if (request == "true") {
      axios
        .post(`api/VizShop/AssignVizShopToRso`, model)
        .then(() => {
          toast.success("Successfully Assign To RSO.");
        })
        .catch(function (error) {});
    } else {
      setShopData({ ...shopData, rsoId: selectedRso.value });
      setRsoModal(false);
    }
  };

  const rejectChanges = () => {
    axios
      .get(`api/VizShop/RejectEditShopChanges/${id}`)
      .then(() => {
        toast.success("Edit Shop Request Rejected");
        history.push(`/VizShopsRequestListing`);
        history.go(`/VizShopsRequestListing`);
      })
      .catch(function (error) {});
  };

  const NavigateToVizShopsList = () => {
    if (request == "true") {
      rejectChanges();
    } else {
      history.push(`/vizLinkShopsList`);
      history.go(`/vizLinkShopsList`);
    }
  };

  useEffect(() => {
    getShopData();
    getShopCategories();
    getRsoList();
    getMfis();
    getDistributorList();
  }, []);

  useEffect(() => {
    setDistributorList(
      props.allDistributorList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.allDistributorList]);

  const CardHeaderToggle = ({ title, isOpen, onToggle, actions }) => (
    <div className="d-flex justify-content-between align-items-center">
      {/* Left: Title */}
      <h5 className="fw-bold text-orange mb-0">{title}</h5>

      {/* Right: Actions + Collapse */}
      <div className="d-flex align-items-center gap-3">
        {actions}

        <span
          onClick={onToggle}
          style={{ cursor: "pointer" }}
          title={isOpen ? "Collapse" : "Expand"}
        >
          <i
            className={`fas fa-chevron-${isOpen ? "up" : "down"}`}
            style={{ color: "#EA5F2D", fontSize: "14px" }}
          ></i>
        </span>
      </div>
    </div>
  );

  return (
    <div className="shop-profile-page p-4">
      <VzPageContainer title="Shop Profile Management">
        {/* ===== Header Row ===== */}
        {/* ===== Header Row ===== */}
        <Row className="align-items-center mb-3">
          <Col md={6}>
            <h4 className="fw-bold mb-0">Shop Profile Management</h4>
          </Col>

          <Col md={6} className="text-end">
            <div className="d-flex justify-content-end align-items-center gap-4">
              {/* Shop Closed Section */}
              <div className="d-flex align-items-center">
                <p className="fw-semibold mt-3 mr-5">Shop Closed:</p>
                <div className=" form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    disabled={_readOnly}
                    checked={!shopData?.isActive}
                    onChange={(e) =>
                      setShopData({ ...shopData, isActive: !e.target.checked })
                    }
                    style={{
                      transform: "scale(1.3)",
                      accentColor: "#e84d15", // Changes the switch color
                    }}
                  />
                  {/* <label className="form-check-label ms-3 ">
              {shopData?.isActive ? "No" : "Yes"}
            </label> */}
                </div>
              </div>

              {/* Viz ID Section */}
              <div className="fw-bold">
                Viz ID:{" "}
                <span style={{ color: "#EA5F2D" }}>
                  {shopData?.vizShopCode}
                </span>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={8}>
            <Card className="p-3 mb-4 shadow-lg mh-auto">
              <h5 className="fw-bold mb-3">Shop & Owner Images</h5>
              <hr />
              <Row className="g-3 mb-4">
                {/* Profile Image */}
                <Col md={3} className="text-center">
                  <p className="fw-semibold">Profile Image</p>
                  {shopData?.profileImage ? (
                    <img
                      src={shopData.profileImage}
                      alt="Profile"
                      className="shadow-sm"
                      style={{
                        width: "140px",
                        height: "140px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "240px",
                        height: "140px",
                      }}
                    >
                      <p className="text-muted fst-italic">
                        Image not available
                      </p>
                    </div>
                  )}
                </Col>

                {/* Shop Image */}
                <Col md={3} className="text-center">
                  <p className="fw-semibold">Shop Image</p>
                  {shopData?.shopImage ? (
                    <img
                      src={shopData.shopImage}
                      alt="Shop"
                      className="img-fluid rounded shadow-sm"
                      style={{ width: "160px", height: "140px" }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "240px",
                        height: "140px",
                      }}
                    >
                      <p className="text-muted fst-italic">
                        Image not available
                      </p>
                    </div>
                  )}
                </Col>

                {/* CNIC Front */}
                <Col md={3} className="text-center">
                  <p className="fw-semibold">CNIC Front</p>
                  {shopData?.cnicFront ? (
                    <img
                      src={shopData.cnicFront}
                      alt="CNIC Front"
                      className="img-fluid rounded shadow-sm"
                      style={{ width: "200px", height: "140px" }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "240px",
                        height: "140px",
                      }}
                    >
                      <p className="text-muted fst-italic">
                        Image not available
                      </p>
                    </div>
                  )}
                </Col>

                {/* CNIC Back */}
                <Col md={3} className="text-center">
                  <p className="fw-semibold">CNIC Back</p>
                  {shopData?.cnicBack ? (
                    <img
                      src={shopData.cnicBack}
                      alt="CNIC Back"
                      className="img-fluid rounded shadow-sm"
                      style={{ width: "200px", height: "140px" }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "240px",
                        height: "140px",
                      }}
                    >
                      <p className="text-muted fst-italic">
                        Image not available
                      </p>
                    </div>
                  )}
                </Col>
              </Row>
            </Card>
            {/* ===== Profile Information (under images) ===== */}
            <Card className="p-3 mb-4 shadow-lg mh-auto">
              <CardHeaderToggle
                title="Profile Information"
                isOpen={showSection.profileInformation}
                onToggle={() => toggleSection("profileInformation")}
              />
              <hr />

              <Collapse in={showSection.profileInformation}>
                <div>
                  <ProfileSection
                    cnic={shopData?.cnic}
                    cnicExpiry={shopData?.cnicExpiry}
                    vizShopName={shopData?.vizShopName}
                    shopCategory={shopData?.shopCategory}
                    shopCategories={shopCategories}
                    ownerName={shopData?.ownerName}
                    ntn={shopData?.ntn}
                    saleTaxNo={shopData?.saleTaxNo}
                    updateData={(data) => setShopData({ ...shopData, ...data })}
                    readOnly={_readOnly}
                  />
                </div>
              </Collapse>
            </Card>
          </Col>

          {/* ===== Right: Address Details ===== */}
          <Col md={4}>
            <Card className="p-3 shadow-lg ">
              <CardHeaderToggle
                title="Address Detail"
                isOpen={showSection.address}
                onToggle={() => toggleSection("address")}
              />
              <hr />
              <Collapse in={showSection.address}>
                <div>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Shop Address
                    </label>
                    <textarea
                      className="form-control"
                      placeholder="Enter shop address"
                      value={shopData?.address || ""}
                      onChange={(e) =>
                        setShopData({ ...shopData, address: e.target.value })
                      }
                      disabled={_readOnly}
                      rows={3} // you can adjust rows as needed
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">Locality</label>
                    <ReactSelect
                      id="area"
                      name="area"
                      className="basic-single"
                      classNamePrefix="select"
                      placeholder="Select locality"
                      isMulti={false}
                      isClearable={true}
                      value={
                        shopData?.area
                          ? { label: shopData.area, value: shopData.area }
                          : null
                      }
                      onChange={(e) =>
                        setShopData({
                          ...shopData,
                          area: e ? e.value : "",
                        })
                      }
                      options={subLocalities}
                      isDisabled={_readOnly}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Sub-locality
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter sub-locality"
                      value={shopData?.locality || ""}
                      onChange={(e) =>
                        setShopData({ ...shopData, locality: e.target.value })
                      }
                      disabled={_readOnly}
                    />
                  </div>

                  {/* Map Preview */}
                  <Col md={12}>
                    <ShopMap ShopMap={shopData} />
                  </Col>
                </div>
              </Collapse>
            </Card>
          </Col>
        </Row>

        {/* ===== Wallet + Contact ===== */}
        <Row>
          <Col md={7}>
            <Card className="p-3 mb-4 shadow-lg mh-auto ">
              <CardHeaderToggle
                title="Wallet Details"
                isOpen={showSection.wallet}
                onToggle={() => toggleSection("wallet")}
                actions={
                  !_readOnly && (
                    <Button
                      size="sm"
                      style={{ background: "#EA5F2D" }}
                      onClick={() => setWalletModal(true)}
                    >
                      Add Another Wallet
                    </Button>
                  )
                }
              />
              <Collapse in={showSection.wallet}>
                <div className="mt-3 mh-400">
                  <WalletSection
                    shopWallets={shopData?.shopWallets}
                    selectedReasonForWalletOrBank={
                      shopData?.selectedReasonForWalletOrBank
                    }
                    reasonDetailsOfWalletOrBank={
                      shopData?.reasonDetailsOfWalletOrBank
                    }
                    mfiList={mfiList}
                    showModal={walletModal}
                    toggleModal={(val) => setWalletModal(val)}
                    updateData={(data) => setShopData({ ...shopData, ...data })}
                    readOnly={_readOnly}
                  />
                </div>
              </Collapse>
            </Card>
          </Col>
          <Col md={5}>
            <Card className="p-3 mb-4 shadow-lg mh-auto ">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="fw-bold text-orange mb-0">
                  Contact Information
                </h5>

                <span
                  onClick={() => toggleSection("contactInformation")}
                  style={{ cursor: "pointer" }}
                >
                  <i
                    className={`fas fa-chevron-${
                      showSection.contactInformation ? "up" : "down"
                    }`}
                    style={{ color: "#EA5F2D" }}
                  ></i>
                </span>
              </div>
              <hr />

              <Collapse in={showSection.contactInformation}>
                <div className="mt-3 mh-380">
                  <ProfileSection
                    isShopOwnerHavePhoneNo={shopData?.isShopOwnerHavePhoneNo}
                    contactNumbers={shopData?.contactNumbers}
                    updateData={(data) => setShopData({ ...shopData, ...data })}
                    readOnly={_readOnly}
                    showOnlyContacts={true}
                  />
                </div>
              </Collapse>
            </Card>
          </Col>
        </Row>
        {request == "true" ? (
          <></>
        ) : (
          <>
            {/* ===== Distributor Profile ===== */}
            <Card className="p-3 mb-4 shadow-lg mh-auto">
              <CardHeaderToggle
                title="Distributor Profile"
                isOpen={showSection.distributorProfile}
                onToggle={() => toggleSection("distributorProfile")}
                actions={
                  !_readOnly && (
                    <Button
                      size="sm"
                      style={{ background: "#EA5F2D" }}
                      onClick={() => setDistributorModal(true)}
                    >
                      Add Another Distributor Shop
                    </Button>
                  )
                }
              />

              <Collapse in={showSection.distributorProfile}>
                <div className="mt-3">
                  <DistributorSection
                    shopDistributors={shopData?.shopDistributors}
                    distributorList={distributorList}
                    showModal={distributorModal}
                    toggleModal={(val) => setDistributorModal(val)}
                    updateData={(data) => setShopData({ ...shopData, ...data })}
                  />
                </div>
              </Collapse>
            </Card>
            {/* ===== Agents ===== */}
            <Card className="p-3 mb-4 shadow-lg mh-auto">
              <CardHeaderToggle
                title="Agents"
                isOpen={showSection.agents}
                onToggle={() => toggleSection("agents")}
              />

              <Collapse in={showSection.agents}>
                <div className="mt-3">
                  <AgentSection
                    shopAgents={shopData?.shopAgents}
                    updateData={(data) => setShopData({ ...shopData, ...data })}
                  />
                </div>
              </Collapse>
            </Card>
          </>
        )}
        {/* ===== Save / Cancel ===== */}
        <Row className="d-flex justify-content-end mt-3">
          <Col>
            <Button
              variant="primary"
              onClick={openRsoModal}
              className="btn btn-primary btn-sm"
              style={{
                background: "#EA5F2D",
              }}
              hidden={_readOnly}
            >
              Re-Allocate to RSO
            </Button>
          </Col>
          <Col className="text-end">
            <Button
              variant=""
              onClick={NavigateToVizShopsList}
              className="btn btn-primary btn-sm"
              style={{
                color: "#EA5F2D",
                background: "white",
              }}
              hidden={_readOnly}
            >
              {!_readOnly && request == "true" ? "Reject Chanages" : "Cancel"}
            </Button>
            <Button
              variant="primary"
              onClick={saveShopData}
              className="btn btn-primary btn-sm ms-3"
              style={{
                background: "#EA5F2D",
              }}
              hidden={_readOnly}
            >
              {!_readOnly && request == "true" ? "Approve Chanages" : "Save"}
            </Button>
          </Col>
        </Row>
        <Modal
          show={rsoModal}
          onHide={() => setRsoModal(false)}
          backdrop="static"
          keyboard={false}
          size="md"
        >
          <Formik>
            {(formik) => (
              <Form autoComplete="off">
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                    Assign Rso
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Container>
                    <Row>
                      <Col md={6}>
                        <div className="form-group ">
                          <ReactSelect
                            id="rsoId"
                            name="rsoId"
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder="Select Rso"
                            isMulti={false}
                            value={selectedRso}
                            isClearable={false}
                            onChange={(e) => {
                              setSelectedRso(e);
                            }}
                            options={rsoList}
                          ></ReactSelect>
                        </div>
                      </Col>
                      <Col md={6}>
                        <Button
                          variant="primary"
                          onClick={setNewRso}
                          className="btn btn-primary btn-sm"
                          style={{
                            background: "#EA5F2D",
                          }}
                        >
                          Assign To Rso
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Modal.Body>
                <Modal.Footer>
                  <>
                    <Button
                      className="btn btn-default"
                      onClick={() => setRsoModal(false)}
                    >
                      Close
                    </Button>
                  </>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
  };
};
export default connect(mapStateToProps, { getDropdownList })(EditShop);

const ProfileSection = ({
  cnic,
  cnicExpiry,
  vizShopName,
  shopCategory,
  shopCategories,
  ownerName,
  isShopOwnerHavePhoneNo,
  contactNumbers,
  ntn,
  saleTaxNo,
  updateData,
  readOnly,
  showOnlyContacts = false, // 👈 add this
}) => {
  const [contactModal, setContactModal] = useState(false);
  const [contact, setContact] = useState("");
  const [selectedContact, setSelectedContact] = useState("");

  const openModal = (isNew, contact = "") => {
    if (isNew) {
      setSelectedContact("");
      setContact("");
    }
    if (!isNew) {
      setSelectedContact(contact);
      setContact(contact);
    }

    setContactModal(true);
  };

  const saveContact = () => {
    if (contact == "") {
      toast.error("Contact field is empty");
      return;
    }

    if (contactNumbers.includes(contact)) {
      toast.error("Contact already exists");
      return;
    }

    if (selectedContact == "") {
      let newContact =
        contactNumbers.length > 0 ? contactNumbers + "," + contact : contact;
      updateData({ contactNumbers: newContact });
    } else {
      let editedContact = contactNumbers.replace(selectedContact, contact);
      updateData({ contactNumbers: editedContact });
    }
    setContactModal(false);
  };

  const deleteContact = (number) => {
    let allContacts = contactNumbers
      .split(",")
      .filter((x) => x != number)
      .join(",");
    updateData({ contactNumbers: allContacts });
  };

  const Delete = (number) => {
    confirmAlert({
      closeOnEscape: true,
      closeOnClickOutside: true,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <Modal.Dialog>
              <Modal.Header id="customized-dialog-title">
                <Modal.Title>Confirm to Delete</Modal.Title>
                <button
                  type="button"
                  onClick={() => onClose()}
                  className="btn-close"
                  aria-label="No"
                ></button>
              </Modal.Header>
              <Modal.Body dividers>
                <p>Are you sure you want to delete this?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => {
                    deleteContact(number);
                    onClose();
                  }}
                  variant="outline-primary"
                >
                  Yes, Delete it!
                </Button>
                <Button
                  variant="primary"
                  onClick={onClose}
                  className="btn btn-primary"
                >
                  No
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </div>
        );
      },
    });
  };

  return (
    <>
      {/* ====== Main Form Section ====== */}
      {!showOnlyContacts ? (
        <>
          <Row>
            <Col>
              <Row>
                <Col md={4} className="d-flex align-items-center">
                  <p>CNIC</p>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <Input
                      value={cnic}
                      onChange={(e) => updateData({ cnic: e.target.value })}
                      type="text"
                      placeholder="Enter Cnic"
                      readOnly={readOnly}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col md={4} className="d-flex align-items-center">
                  <p>CNIC Expiry Date</p>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <Input
                      type="date"
                      value={
                        cnicExpiry
                          ? new Date(cnicExpiry).toISOString().substring(0, 10)
                          : ""
                      }
                      onChange={(e) =>
                        updateData({ cnicExpiry: e.target.value })
                      }
                      placeholder="Enter CNIC Expiry Date"
                      readOnly={readOnly}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col>
              <Row>
                <Col md={4} className="d-flex align-items-center">
                  <p>Shop Name</p>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <Input
                      value={vizShopName}
                      onChange={(e) =>
                        updateData({ vizShopName: e.target.value })
                      }
                      type="text"
                      placeholder="Enter Shop Name"
                      readOnly={readOnly}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col md={4} className="d-flex align-items-center">
                  <p>Shop Category</p>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <ReactSelect
                      id="shopCategory"
                      name="shopCategory"
                      classNamePrefix="select"
                      placeholder="Select Category"
                      isMulti={false}
                      value={{
                        label: shopCategory,
                        value: shopCategory,
                      }}
                      isClearable={false}
                      onChange={(e) => updateData({ shopCategory: e.value })}
                      options={shopCategories}
                      isDisabled={readOnly}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col>
              <Row>
                <Col md={4} className="d-flex align-items-center">
                  <p>Shop Owner Name</p>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <Input
                      value={ownerName}
                      onChange={(e) =>
                        updateData({ ownerName: e.target.value })
                      }
                      type="text"
                      placeholder="Enter Owner Name"
                      readOnly={readOnly}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col md={4} className="d-flex align-items-center">
                  <p>NTN No.</p>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <Input
                      value={ntn}
                      onChange={(e) => updateData({ ntn: e.target.value })}
                      type="text"
                      placeholder="Enter NTN"
                      readOnly={readOnly}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={2} className="d-flex align-items-center">
              <p>Sale Tax No.</p>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <Input
                  value={saleTaxNo}
                  onChange={(e) => updateData({ saleTaxNo: e.target.value })}
                  type="text"
                  placeholder="Enter Sale Tax No"
                  readOnly={readOnly}
                />
              </div>
            </Col>
          </Row>
        </>
      ) : (
        <>
          {/* ====== Contact-Only View ====== */}
          <Row>
            <Col>
              {contactNumbers?.length > 0 && (
                <table className="table table-borderless align-middle mb-0">
                  <tbody>
                    {contactNumbers?.split(",").map((value, index) => (
                      <tr key={index}>
                        <td colSpan={3}>
                          <div className="form-group">
                            <Input
                              value={value}
                              type="text"
                              placeholder="Enter contact number"
                              readOnly={true}
                            />
                          </div>
                        </td>
                        <td colSpan={3}>
                          <div>
                            <button
                              title="Edit Contact"
                              onClick={() => openModal(false, value)}
                              className="btn btn-sm"
                              hidden={readOnly}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                            &nbsp;
                            <button
                              onClick={() => Delete(value)}
                              className="btn btn-sm"
                              hidden={readOnly}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={9}>
              <Row>
                <Col md={4} className="d-flex align-items-center">
                  <p>Smart Phone:</p>
                </Col>
                <Col md={6}>
                  <div className="form-check form-switch pr-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      disabled={readOnly}
                      checked={!isShopOwnerHavePhoneNo} // toggle logic
                      onChange={(e) =>
                        updateData({
                          isShopOwnerHavePhoneNo: !e.target.checked,
                        })
                      }
                      style={{
                        transform: "scale(1.3)",
                        accentColor: "#e84d15", // toggle color
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={3}>
              <Button
                variant="primary"
                onClick={() => openModal(true, "")}
                className="btn btn-primary btn-sm"
                style={{
                  background: "#EA5F2D",
                }}
                hidden={readOnly}
              >
                Add More
              </Button>
            </Col>
          </Row>
        </>
      )}

      {/* ====== Contact Modal ====== */}
      <Modal
        show={contactModal}
        onHide={() => setContactModal(false)}
        backdrop="static"
        keyboard={false}
        size="md"
      >
        <Formik>
          {() => (
            <Form autoComplete="off">
              <Modal.Header closeButton>
                <Modal.Title>Contact Number</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Container>
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <Input
                          value={contact}
                          onChange={(e) => setContact(e.target.value)}
                          type="text"
                          placeholder="Enter contact number"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <Button
                        variant="primary"
                        onClick={saveContact}
                        className="btn btn-primary btn-sm"
                        style={{ background: "#EA5F2D" }}
                      >
                        Add Contact Number
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-default"
                  onClick={() => setContactModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

const AddressSection = ({
  address,
  locality,
  area,
  lat,
  long,
  mapAddress,
  subLocalities,
  updateData,
  readOnly,
}) => {
  return (
    <>
      <Row>
        <Col md={2} className="d-flex align-items-center">
          <p>Shop Address</p>
        </Col>
        <Col md={8}>
          <div className="form-group ">
            <Input
              value={address}
              onChange={(e) =>
                updateData({
                  address: e.target.value,
                })
              }
              type="text"
              placeholder="Enter address"
              readOnly={readOnly}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col className="">
          <Row>
            <Col md={4} className="d-flex align-items-center">
              <p>Locality</p>
            </Col>
            <Col md={6}>
              <div className="form-group ">
                <ReactSelect
                  id="area"
                  name="area"
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select sub-locality"
                  isMulti={false}
                  value={{
                    label: area,
                    value: area,
                  }}
                  isClearable={false}
                  onChange={(e) => {
                    updateData({
                      area: e.value,
                    });
                  }}
                  options={subLocalities}
                  isDisabled={readOnly}
                ></ReactSelect>
              </div>
            </Col>
          </Row>
        </Col>
        <Col className="">
          <Row>
            <Col md={4} className="d-flex align-items-center">
              <p>sub-locality</p>
            </Col>
            <Col md={6}>
              <div className="form-group ">
                <Input
                  value={locality}
                  onChange={(e) =>
                    updateData({
                      locality: e.target.value,
                    })
                  }
                  type="text"
                  placeholder="Enter locality"
                  width={"100%"}
                  readOnly={readOnly}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col md={4} className="d-flex align-items-center">
              <p>Lat</p>
            </Col>
            <Col md={6}>
              {" "}
              <div className="form-group ">
                <Input
                  value={lat}
                  onChange={(e) =>
                    updateData({
                      lat: e.target.value,
                    })
                  }
                  type="text"
                  placeholder="Enter lat"
                  readOnly={readOnly}
                />
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row>
            <Col md={4} className="d-flex align-items-center">
              <p>Long</p>
            </Col>
            <Col md={6}>
              {" "}
              <div className="form-group ">
                <Input
                  value={long}
                  onChange={(e) =>
                    updateData({
                      long: e.target.value,
                    })
                  }
                  type="text"
                  placeholder="Enter long"
                  readOnly={readOnly}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={2} className="d-flex align-items-center">
          <p>Map Address</p>
        </Col>
        <Col md={8}>
          <div className="form-group ">
            <Input
              value={mapAddress}
              onChange={(e) => updateData({ mapAddress: e.target.value })}
              type="text"
              placeholder="Enter map address"
              readOnly={readOnly}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

const WalletSection = ({
  shopWallets,
  selectedReasonForWalletOrBank,
  reasonDetailsOfWalletOrBank,
  mfiList,
  updateData,
  showModal,
  toggleModal,
  readOnly,
}) => {
  const walletInitialValues = {
    id: null,
    isL2: false,
    mfiId: "",
    mfiName: "",
    walletNumber: "",
    requiredLimit: "",
  };

  const [walletDetails, setWalletDetails] = useState(walletInitialValues);
  const [walletLimits, setWalletLimits] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(null);

  const columns = [
    {
      Header: "MFI",
      accessor: "mfiName",
      Cell: ({ value }) =>
        value?.toLowerCase() === "onebill" ? "1Bill" : value,
    },
    {
      Header: "Wallet Number",
      accessor: "walletNumber",
    },
    {
      Header: "Required Wallet",
      accessor: "isL2",
      Cell: (row) => (
        <div>{row.row.original.isL2 ? "L2" : "L1"}</div>
      ),
    },
    {
      Header: "Required Limit",
      accessor: "requiredLimit",
    },
  ];

  if (!readOnly) {
    columns.push({
      Header: "Decision",
      accessor: "id",
      Cell: (row) => (
        <div>
          <button
            title="Edit"
            onClick={() => openModalForEdit(row.row.original)}
            className="btn btn-sm"
          >
            <i className="fas fa-edit"></i>
          </button>
          &nbsp;
          <button
            onClick={() => Delete(row.row.original)}
            className="btn btn-sm"
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
    });
  }

  const getWalletLimits = (mfiId) => {
    if (!mfiId) return;

    axios
      .get(`api/Mfi/GetMfiRequiredLimitsDDL/${mfiId}`)
      .then(({ data }) => {
        setWalletLimits(
          data?.response?.map((x) => ({
            value: x.name,
            label: x.name,
          })) ?? []
        );
      })
      .catch(() => setWalletLimits([]));
  };

  const clearAndCloseModal = () => {
    setWalletDetails(walletInitialValues);
    setCurrentIndex(null);
    toggleModal(false);
  };

  const openModalForEdit = (wallet) => {
    if (!wallet) return;

    const index = shopWallets.findIndex(
      (x) =>
        x.mfiId === wallet.mfiId &&
        x.walletNumber === wallet.walletNumber
    );

    if (index === -1) return;

    setCurrentIndex(index);

    setWalletDetails({
      id: wallet.id,
      isL2: wallet.isL2,
      mfiId: wallet.mfiId,
      mfiName: wallet.mfiName,
      walletNumber: wallet.walletNumber,
      requiredLimit: wallet.requiredLimit,
    });

    toggleModal(true);
    getWalletLimits(wallet.mfiId);
  };

  const checkDuplicateWallet = (wallet) => {
    return shopWallets.some(
      (x, idx) =>
        idx !== currentIndex &&
        x.mfiId === wallet.mfiId &&
        x.walletNumber === wallet.walletNumber
    );
  };

  const saveAndCloseModal = () => {
    if (!walletDetails.mfiId || !walletDetails.walletNumber) {
      toast.error("Please provide complete wallet details");
      return;
    }

    if (checkDuplicateWallet(walletDetails)) {
      toast.error("Wallet already exists");
      return;
    }

    const wallets =
      currentIndex === null
        ? [...shopWallets, walletDetails]
        : shopWallets.map((w, i) =>
            i === currentIndex ? walletDetails : w
          );

    updateData({ shopWallets: wallets });
    clearAndCloseModal();
  };

  const deleteWallet = (wallet) => {
    const wallets = shopWallets.filter((x) => x !== wallet);
    updateData({ shopWallets: wallets });
  };

  const Delete = (wallet) => {
    confirmAlert({
      closeOnEscape: true,
      closeOnClickOutside: true,
      customUI: ({ onClose }) => (
        <div className="custom-ui">
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Title>Confirm to Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => {
                  deleteWallet(wallet);
                  onClose();
                }}
                variant="outline-primary"
              >
                Yes, Delete it!
              </Button>
              <Button variant="primary" onClick={onClose}>
                No
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      ),
    });
  };

  return (
    <>
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <CustomDataTable
          data={shopWallets ?? []}
          columns={columns}
          getTrProps={() => null}
          IsPagingEnable={false}
          IsSearchEnable={false}
          minHeight="220px"
        />
      </div>
      <Row className="mt-2">
        <Col>
          <h6
            style={{
              color: "#EA5F2D",
              fontWeight: "bold",
            }}
          >
            Reasons For Not Using Wallet
          </h6>
          <div className="ms-12 my-12 ">
            <input
              checked={
                selectedReasonForWalletOrBank ==
                "Not suitable for digital payments"
              }
              value={selectedReasonForWalletOrBank}
              type="checkbox"
              onChange={(event) =>
                updateData({
                  selectedReasonForWalletOrBank:
                    "Not suitable for digital payments",
                })
              }
              style={{ transform: "scale(1.3)" }}
              disabled={readOnly}
            />
            <span className="ms-2">Not suitable for digital payments</span>
            <span className="ms-5"></span>
            <input
              checked={
                selectedReasonForWalletOrBank == "Not willing to share details"
              }
              value={selectedReasonForWalletOrBank}
              type="checkbox"
              onChange={(event) =>
                updateData({
                  selectedReasonForWalletOrBank: "Not willing to share details",
                })
              }
              style={{ transform: "scale(1.3)" }}
              disabled={readOnly}
            />
            <span className="ms-2">Not willing to share details</span>
            <span className="ms-5"></span>
            <input
              checked={
                selectedReasonForWalletOrBank == "Not willing to register"
              }
              value={selectedReasonForWalletOrBank}
              type="checkbox"
              onChange={(event) =>
                updateData({
                  selectedReasonForWalletOrBank: "Not willing to register",
                })
              }
              style={{ transform: "scale(1.5)" }}
              disabled={readOnly}
            />
            <span className="ms-2">Not willing to register</span>
          </div>
        </Col>
      </Row>

      <Row>
        <p>Other Reason</p>
        <Col md={6}>
          <div className="form-group ">
            <Input
              value={reasonDetailsOfWalletOrBank}
              onChange={(e) =>
                updateData({ reasonDetailsOfWalletOrBank: e.target.value })
              }
              type="text"
              placeholder="Enter reason"
              readOnly={readOnly}
            />
          </div>
        </Col>
      </Row>

      <Modal
        show={showModal}
        onHide={clearAndCloseModal}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Formik>
          {(formik) => (
            <Form autoComplete="off">
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  Add Wallet
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Container>
                  <Row>
                    <Col md={6}>
                      <p>MFI</p>
                      <div className="form-group ">
                        <ReactSelect
                          id="mfiId"
                          name="mfiId"
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="Select Mfi"
                          isMulti={false}
                          value={{
                            value: walletDetails.mfiId,
                            label: walletDetails.mfiName,
                          }}
                          isClearable={false}
                          onChange={(e) => (
                            setWalletDetails({
                              ...walletDetails,
                              mfiId: e.value,
                              mfiName: e.label,
                            }),
                            getWalletLimits(e.value)
                          )}
                          options={mfiList}
                        ></ReactSelect>
                      </div>
                    </Col>
                    <Col md={6}>
                      <p>Wallet</p>
                      <Input
                        value={walletDetails.walletNumber}
                        onChange={(e) =>
                          setWalletDetails({
                            ...walletDetails,
                            walletNumber: e.target.value,
                          })
                        }
                        type="text"
                        placeholder="Enter wallet number"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <p>Required Limit(Optional)</p>
                      <div className="form-group ">
                        <ReactSelect
                          id="requiredLimit"
                          name="requiredLimit"
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="Select Wallet Limit"
                          isMulti={false}
                          value={{
                            value: walletDetails.requiredLimit,
                            label: walletDetails.requiredLimit,
                          }}
                          isClearable={false}
                          onChange={(e) => {
                            setWalletDetails({
                              ...walletDetails,
                              requiredLimit: e.value,
                            });
                          }}
                          options={walletLimits}
                        ></ReactSelect>
                      </div>
                    </Col>
                    <Col md={6}>
                      <p>Required L2</p>
                      <div className="d-flex ">
                        <input
                          checked={walletDetails?.isL2}
                          value={walletDetails?.isL2}
                          type="checkbox"
                          onChange={(event) =>
                            setWalletDetails({
                              ...walletDetails,
                              isL2: true,
                            })
                          }
                          style={{ transform: "scale(1.3)" }}
                        />
                        <span className="ms-2">Yes</span>

                        <input
                          checked={!walletDetails?.isL2}
                          value={walletDetails?.isL2}
                          type="checkbox"
                          onChange={(event) =>
                            setWalletDetails({
                              ...walletDetails,
                              isL2: false,
                            })
                          }
                          style={{ transform: "scale(1.3)" }}
                          className="ms-4"
                        />
                        <span className="ms-2">No</span>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Modal.Body>
              <Modal.Footer>
                <>
                  <Button
                    className="btn btn-default"
                    onClick={clearAndCloseModal}
                  >
                    Close
                  </Button>

                  <Button
                    variant="primary"
                    onClick={saveAndCloseModal}
                    className="btn btn-primary btn-sm ms-2"
                    style={{
                      background: "#EA5F2D",
                    }}
                  >
                    Save
                  </Button>
                </>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};


const DistributorSection = ({
  shopDistributors,
  distributorList,
  showModal,
  toggleModal,
  updateData,
}) => {
  const filterInitialValues = {
    distributorId: "",
    distributorName: "",
    centerId: "",
    centerName: "",
    shopCode: "",
  };

  const [filterValues, setFilterValues] = useState(filterInitialValues);
  const [centerList, setCenterList] = useState([]);
  const [distShopList, setDistShopList] = useState([]);
  const [paginatedList, setPaginatedList] = useState([]);

  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");

  const selectRecord = (row) => {
    let list = [...paginatedList];
    list[row.row.id].isSelected = !list[row.row.id].isSelected;

    setPaginatedList(list);

    // let list = [...paginatedList]
    // list[row.row.id].isSelected = !list[row.row.id].isSelected

    // setDistShopList(list)
  };

  const columns = [
    {
      Header: "Select",
      accessor: "id",
      Cell: (row) => (
        <div className="ms-2 my-2 " key={1}>
          <input
            checked={row.row.original.isSelected}
            value={row.row.original.isSelected}
            type="checkbox"
            onChange={() => selectRecord(row)}
            style={{ transform: "scale(1.3)" }}
          />
          <span className="ms-2"></span>
        </div>
      ),
    },
    {
      Header: "Distributors Name",
      accessor: "distributorName",
    },
    {
      Header: "Distribution ID",
      accessor: "centerName",
    },
    {
      Header: "Shop Code",
      accessor: "shopCode",
    },
    {
      Header: "Shop Name",
      accessor: "shopName",
    },
    {
      Header: "Average Sales",
      accessor: "averageSales",
    },
    {
      Header: "Payment Mode",
      accessor: "paymentMode",
    },
  ];

  const addedColumns = [
    {
      Header: "Distributors Name",
      accessor: "distributorName",
    },
    {
      Header: "Distribution ID",
      accessor: "centerName",
    },
    {
      Header: "Shop Code",
      accessor: "shopCode",
    },
    {
      Header: "Shop Name",
      accessor: "shopName",
    },
    {
      Header: "Average Sales",
      accessor: "averageSales",
    },
    {
      Header: "Payment Mode",
      accessor: "paymentMode",
    },
    {
      Header: "",
      accessor: "id",
      Cell: (row) => (
        <div>
          <button
            onClick={() => Delete(row.row.id)}
            className="btn btn-sm"
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const clearData = () => {
    setCenterList([]);
    setDistShopList([]);
    setPaginatedList([]);
    setCurrentPageNo(0);
    setCurrentPageSize(5);
    setSearchText("");
  };

  const clearAndCloseModal = () => {
    setFilterValues(filterInitialValues);
    toggleModal(false);
    clearData();
  };

  const saveAndCloseModal = () => {
    let allDists = [
      ...shopDistributors,
      ...distShopList.filter((x) => x.isSelected == true),
    ];
    updateData({ shopDistributors: allDists });

    setFilterValues(filterInitialValues);
    toggleModal(false);
    clearData();
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    setPaginatedList(distShopList.slice(0, pageSize));
  };

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setSearchText(text);

    setPaginatedList(distShopList.filter((x) => x.shopCode.includes(text)));
  };

  const getData = (page) => {
    setCurrentPageNo(page);

    let index = page * currentPageSize;
    setPaginatedList(distShopList.slice(index, index + currentPageSize));
  };

  const getCenterList = (id) => {
    axios
      .post(`api/DistCenter/GetDistCentersDDL`, {distributorIds: id})
      .then(({ data }) => {
        setCenterList(data?.response);
      })
      .catch(function (error) {});
  };

  const getDistShopList = (id) => {
    axios
      .get(`api/VizShop/GetDistributorCenterShops/${id}`)
      .then(({ data }) => {
        setDistShopList(data);
        setPaginatedList(data.slice(0, currentPageSize));
      })
      .catch(function (error) {});
  };

  const deleteDistributor = (id) => {
    updateData({
      shopDistributors: shopDistributors.filter((x) => x.id != id),
    });

    if (shopDistributors.length == 1) {
      toast.error(
        "One distributor is compulsory to add otherwise this shop record will be inactive"
      );
    }
  };

  const Delete = (id) => {
    confirmAlert({
      closeOnEscape: true,
      closeOnClickOutside: true,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <Modal.Dialog>
              <Modal.Header id="customized-dialog-title">
                <Modal.Title>Confirm to Delete</Modal.Title>
                <button
                  type="button"
                  onClick={() => onClose()}
                  className="btn-close"
                  aria-label="No"
                ></button>
              </Modal.Header>
              <Modal.Body dividers>
                <p>Are you sure you want to delete this?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => {
                    deleteDistributor(id);
                    onClose();
                  }}
                  variant="outline-primary"
                >
                  Yes, Delete it!
                </Button>
                <Button
                  variant="primary"
                  onClick={onClose}
                  className="btn btn-primary"
                >
                  No
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </div>
        );
      },
    });
  };
  return (
    <>
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <ScrollableNoPagingDataTable
          columns={addedColumns}
          data={shopDistributors ?? []}
          IsSearchEnable={false}
          tableHeight="300px"
        />
        {/* <CustomDataTable
          data={shopDistributors ?? []}
          columns={addedColumns}
          getTrProps={() => null}
          IsPagingEnable={false}
          IsSearchEnable={false}
          minHeight= "auto" 
        /> */}
      </div>
      <Modal
        show={showModal}
        onHide={clearAndCloseModal}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Formik>
          {(formik) => (
            <Form autoComplete="off">
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Container>
                  <Row>
                    <Col md={6}>
                      <Row className="d-flex align-items-center">
                        <Col md={4}>Select Distributor</Col>
                        <Col md={8}>
                          <div className="form-group m-0">
                            <ReactSelect
                              id="distributorId"
                              name="distributorId"
                              className="basic-single"
                              classNamePrefix="select"
                              placeholder="Select Distributor"
                              isMulti={false}
                              value={{
                                value: filterValues.distributorId,
                                label: filterValues.distributorName,
                              }}
                              isClearable={false}
                              onChange={(e) =>
                                setFilterValues(
                                  {
                                    ...filterValues,
                                    distributorId: e.value,
                                    distributorName: e.label,
                                    centerId: "",
                                    centerName: "",
                                  },
                                  getCenterList(e.value)
                                )
                              }
                              options={distributorList}
                            ></ReactSelect>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row className="d-flex align-items-center">
                        <Col md={4}>Select Distribution</Col>
                        <Col md={8}>
                          <div className="form-group m-0">
                            <ReactSelect
                              id="centerId"
                              name="centerId"
                              className="basic-single"
                              classNamePrefix="select"
                              placeholder="Select Distribution"
                              isMulti={false}
                              value={{
                                value: filterValues.centerId,
                                label: filterValues.centerName,
                              }}
                              isClearable={false}
                              onChange={(e) =>
                                setFilterValues(
                                  {
                                    ...filterValues,
                                    centerId: e.value,
                                    centerName: e.label,
                                  },
                                  getDistShopList(e.value)
                                )
                              }
                              options={centerList}
                            ></ReactSelect>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col>
                      {/* <CustomDataTable
                        searchLabel='Search Shop Code'
                        data={distShopList}
                        columns={columns}
                        getTrProps={() => null}
                        IsPagingEnable={false}
                      /> */}
                      <ServerSideDataTable
                        searchLabel="Search Shop Code"
                        data={paginatedList ? paginatedList : []}
                        columns={columns}
                        getTrProps={() => null}
                        goToPreviousPage={(val) => getData(val)}
                        goToNextPage={(val) => getData(val)}
                        totalRecords={distShopList.length}
                        pageSizeChange={(size) => pageSizeChanged(size)}
                        myPageSize={currentPageSize}
                        pageNo={currentPageNo}
                        searchChanged={searchChanged}
                      />
                    </Col>
                  </Row>
                </Container>
              </Modal.Body>
              <Modal.Footer>
                <>
                  <Button
                    className="btn btn-default"
                    onClick={clearAndCloseModal}
                  >
                    Close
                  </Button>

                  <Button
                    variant="primary"
                    onClick={saveAndCloseModal}
                    className="btn btn-primary btn-sm ms-2"
                    style={{
                      background: "#EA5F2D",
                    }}
                  >
                    Save
                  </Button>
                </>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

const AgentSection = ({ shopAgents, updateData }) => {
  const unTagAgent = (id) => {
    let newAgentList = shopAgents.filter((x) => x.id != id);
    updateData({ shopAgents: newAgentList });
  };

  const columns = [
    {
      Header: "Agent Code",
      accessor: "vizAgentCode",
    },
    {
      Header: "Business Name",
      accessor: "agentBusinessName",
    },
    {
      Header: "Owner Name",
      accessor: "agentOwnerName",
    },
    {
      Header: "Owner Cnic",
      accessor: "agentOwnerNic",
    },
    {
      Header: "Agent Type",
      accessor: "agentType",
    },
    {
      Header: "Contact",
      accessor: "contactNumber",
    },

    {
      Header: "Decision",
      accessor: "id",
      Cell: (row) => (
        <div
          i
          style={{ color: "#ea5f2d", cursor: "pointer" }}
          onClick={() => unTagAgent(row.row.original.id)}
        >
          Untag
        </div>
      ),
    },
  ];
  return (
    <>
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <ScrollableNoPagingDataTable
          data={shopAgents ?? []}
          columns={columns}
          IsSearchEnable={false}
          tableHeight="300px"
        />
        {/* <CustomDataTable
          data={shopAgents ?? []}
          columns={columns}
          getTrProps={() => null}
          IsPagingEnable={false}
          IsSearchEnable={false}
          minHeight= "auto" 
        /> */}
      </div>
    </>
  );
};
